/**
 * 学习乐园 · 斑马谜题（game-zebra.js）
 * ============================================================
 * 「逻辑与推理」组收官作：几栋房子排成一排，每栋住谁、刷什么色、喝什么、
 * 养什么、爱什么——只给一堆关系线索，推出唯一解。三档：入门 3 栋房×3
 * 项属性（默认档）、进阶 4×4、挑战 5×5 经典斑马规模。
 *
 * 出题管线：每局先随机生成一个解（每项属性独立洗牌排列），再从「与解一致
 * 的全部线索」里洗牌后贪心加入（直接指认 / 同院 / 左邻 / 相邻四类），每加
 * 一条都用回溯求解器数解，数到唯一解立刻收手——所以每局线索集都是「恰好
 * 唯一」的最小集，且顺序随机、每局不同。求解器与线索校验全部在浏览器本地
 * 跑（毫秒级），不上传任何数据。
 *
 * 交互：表格一行一栋房，点格子轮换候选；填对填错不即时判——「查一查」按
 * 唯一解找出第一个错格，讲正确答案与相关线索文本。撤销随时可用；不计时；
 * 成绩按档记完成局数，存本机 localStorage。
 *
 * 冒烟钩子：window.STZebra 暴露 solveCount / genPuzzle / clueText / state()。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-zebra';
  var RECORD_KEY = 'study-zebra-record';

  /* ============ 属性与值池 ============ */
  /* 每项属性一个值池（挑战 5×5 全取，入门 3×3 取前 3 个）。 */
  var ATTRS = [
    { key: 'color', name: '颜色', vals: ['红色', '蓝色', '绿色', '黄色', '白色'] },
    { key: 'nation', name: '国籍', vals: ['英国人', '法国人', '德国人', '日本人', '中国人'] },
    { key: 'drink', name: '饮料', vals: ['茶', '咖啡', '牛奶', '果汁', '水'] },
    { key: 'pet', name: '宠物', vals: ['猫', '狗', '鸟', '鱼', '龟'] },
    { key: 'hobby', name: '爱好', vals: ['读书', '养花', '下棋', '画画', '听音乐'] }
  ];

  var LEVELS = [
    { mode: 'easy', name: '入门', hint: '3 栋房 × 3 项', n: 3 },
    { mode: 'mid', name: '进阶', hint: '4 栋房 × 4 项', n: 4 },
    { mode: 'hard', name: '挑战', hint: '5 栋房 × 5 项 · 经典斑马规模', n: 5 }
  ];

  function rnd(n) { return Math.floor(Math.random() * n); }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = rnd(i + 1), t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* ============ 线索 ============ */
  /* 四类：
     direct {attr, house, val}：房 house 的 attr 是 vals[val]（house 从 0 计）
     same   {a1, v1, a2, v2}  ：attr1=v1 和 attr2=v2 同一栋房
     left   {a1, v1, a2, v2}  ：attr1=v1 紧挨在 attr2=v2 左边（房号小 1）
     next   {a1, v1, a2, v2}  ：attr1=v1 和 attr2=v2 相邻（左右都算） */

  function clueText(c, attrs, n) {
    if (c.type === 'direct') {
      var A0 = attrs[c.attr];
      return '住第 ' + (c.house + 1) + ' 栋房的' + (A0.name === '国籍' ? '是' + A0.vals[c.val] : A0.name + '是' + A0.vals[c.val]);
    }
    var A1 = attrs[c.a1], A2 = attrs[c.a2];
    var v1 = A1.vals[c.v1], v2 = A2.vals[c.v2];
    if (c.type === 'same') return '住' + v1 + '的和' + (A2.name === '国籍' ? '是' + v2 + '的那位' : A2.name + '是' + v2 + '的那位') + '是同一栋房';
    if (c.type === 'left') return '住' + v1 + '的紧挨在' + (A2.name === '国籍' ? v2 + '那位' : A2.name + '是' + v2 + '的那位') + '的左边';
    if (c.type === 'next') return '住' + v1 + '的和' + (A2.name === '国籍' ? v2 + '那位' : A2.name + '是' + v2 + '的那位') + '住在隔壁';
    return '';
  }

  /* ============ 求解器：回溯数解 ============ */
  /* grid[r][a] = v：房 r 的属性 a 取值 v。线索校验在每次新赋值后做。 */
  function clueOk(c, grid) {
    var i, prev;
    if (c.type === 'direct') return grid[c.house][c.attr] === c.val;
    if (c.type === 'same') {
      for (i = 0; i < grid.length; i++) {
        if (grid[i][c.a1] === c.v1) {
          if (grid[i][c.a2] < 0) return true; // 同房属性未填，先放过
          return grid[i][c.a2] === c.v2;
        }
      }
      return true; // v1 还没放，先放过（回溯到齐再验）
    }
    if (c.type === 'left') {
      // 语义：a1=v1 紧挨在 a2=v2 的左边 → a2 应在 a1 的右邻房（i+1）
      for (i = 0; i < grid.length; i++) {
        if (grid[i][c.a1] === c.v1) {
          if (i + 1 >= grid.length) return false; // 右边没有房，必违反
          prev = grid[i + 1][c.a2];
          if (prev < 0) return true; // 未填，先放过
          return prev === c.v2;
        }
      }
      return true;
    }
    if (c.type === 'next') {
      for (i = 0; i < grid.length; i++) {
        if (grid[i][c.a1] === c.v1) {
          var canL = i > 0, canR = i + 1 < grid.length;
          if (canL && grid[i - 1][c.a2] === c.v2) return true;
          if (canR && grid[i + 1][c.a2] === c.v2) return true;
          var lUndecided = canL && grid[i - 1][c.a2] < 0;
          var rUndecided = canR && grid[i + 1][c.a2] < 0;
          if (lUndecided || rUndecided) return true; // 有邻居未填，先放过
          return false; // 所有可能邻居已确定且都不匹配
        }
      }
      return true;
    }
    return true;
  }

  function cluesOk(cs, grid) {
    for (var i = 0; i < cs.length; i++) {
      if (!clueOk(cs[i], grid)) return false;
    }
    return true;
  }

  /* 数解：按「属性排列」DFS——每项属性一个 n! 排列，线索按最大属性索引分桶，
     第 a 层选属性 a 的排列并验桶内线索（涉及属性都已定的线索在此被剪），
     同属性唯一性由排列天然保证。数到 limit 停。 */
  var PERMS = {};

  function solveCount(n, clues, limit) {
    var perms = PERMS[n] || (PERMS[n] = (function () {
      var res = [], cur = new Array(n).fill(-1);
      function rec(depth, used) {
        if (depth === n) { res.push(cur.slice()); return; }
        for (var v = 0; v < n; v++) {
          if (used[v]) continue;
          used[v] = true; cur[depth] = v;
          rec(depth + 1, used);
          used[v] = false; cur[depth] = -1;
        }
      }
      rec(0, new Array(n).fill(false));
      return res;
    })());
    var buckets = [];
    for (var k = 0; k < n; k++) buckets.push([]);
    for (var i = 0; i < clues.length; i++) {
      var c = clues[i];
      var mx = c.type === 'direct' ? c.attr : (c.a1 > c.a2 ? c.a1 : c.a2);
      buckets[mx].push(c);
    }
    var chosen = [];
    var count = 0;
    function check(c) {
      if (c.type === 'direct') return chosen[c.attr][c.house] === c.val;
      var h1 = chosen[c.a1].indexOf(c.v1), h2 = chosen[c.a2].indexOf(c.v2);
      if (c.type === 'same') return h1 === h2;
      if (c.type === 'left') return h1 + 1 === h2;
      return Math.abs(h1 - h2) === 1;
    }
    function dfs(a) {
      if (count >= limit) return;
      if (a === n) { count++; return; }
      var bucket = buckets[a];
      for (var pi = 0; pi < perms.length; pi++) {
        chosen[a] = perms[pi];
        var ok = true;
        for (var bi = 0; bi < bucket.length; bi++) {
          if (!check(bucket[bi])) { ok = false; break; }
        }
        if (ok) dfs(a + 1);
        if (count >= limit) return;
      }
      chosen[a] = null;
    }
    dfs(0);
    return count;
  }

  /* ============ 出题：随机解 + 线索池贪心到唯一解 ============ */

  function makeSolution(n) {
    var grid = [];
    for (var a = 0; a < n; a++) {
      var perm = shuffle(new Array(n).fill(0).map(function (_, i) { return i; }));
      for (var r = 0; r < n; r++) {
        if (a === 0) grid.push(new Array(n));
        grid[r][a] = perm[r];
      }
    }
    return grid;
  }

  function buildPool(n, sol) {
    var pool = [];
    var a1, a2, v1, v2, r;
    for (a1 = 0; a1 < n; a1++) {
      for (r = 0; r < n; r++) pool.push({ type: 'direct', attr: a1, house: r, val: sol[r][a1] });
    }
    for (a1 = 0; a1 < n; a1++) {
      for (a2 = a1 + 1; a2 < n; a2++) {
        for (v1 = 0; v1 < n; v1++) {
          for (v2 = 0; v2 < n; v2++) {
            var h1 = -1, h2 = -1;
            for (r = 0; r < n; r++) {
              if (sol[r][a1] === v1) h1 = r;
              if (sol[r][a2] === v2) h2 = r;
            }
            if (h1 === h2) pool.push({ type: 'same', a1: a1, v1: v1, a2: a2, v2: v2 });
            else if (h1 + 1 === h2) {
              pool.push({ type: 'left', a1: a1, v1: v1, a2: a2, v2: v2 });
              pool.push({ type: 'next', a1: a1, v1: v1, a2: a2, v2: v2 });
            } else if (h2 + 1 === h1) {
              pool.push({ type: 'next', a1: a1, v1: v1, a2: a2, v2: v2 });
            }
          }
        }
      }
    }
    return pool;
  }

  /* 生成一局：尝试若干次，拿到「线索池够用且贪心到唯一解」的题。 */
  function genPuzzle(n, maxPicks) {
    for (var attempt = 0; attempt < 30; attempt++) {
      var sol = makeSolution(n);
      var pool = shuffle(buildPool(n, sol));
      var clues = [];
      for (var i = 0; i < pool.length && i < (maxPicks || 60); i++) {
        clues.push(pool[i]);
        if (solveCount(n, clues, 2) === 1) {
          return { sol: sol, clues: clues };
        }
      }
    }
    // 兜底：直接线索全集必唯一
    var sol2 = makeSolution(n), clues2 = [];
    for (var a = 0; a < n; a++) for (var r = 0; r < n; r++) clues2.push({ type: 'direct', attr: a, house: r, val: sol2[r][a] });
    return { sol: sol2, clues: clues2 };
  }

  /* ============ 界面与交互 ============ */

  var root = null, ui = {};
  var S = {
    mode: 'easy', n: 3, attrs: [], sol: [], clues: [], grid: [],
    hist: [], ended: false, soundOn: true, resetArm: false, resetTimer: null
  };

  function el(tag, cls, text) {
    var d = document.createElement(tag);
    if (cls) d.className = cls;
    if (text !== undefined) d.textContent = text;
    return d;
  }

  function newGame(levelIdx) {
    var lv = LEVELS[levelIdx];
    S.mode = lv.mode;
    S.n = lv.n;
    S.attrs = ATTRS.slice(0, lv.n).map(function (a) {
      return { key: a.key, name: a.name, vals: a.vals.slice(0, lv.n) };
    });
    var pz = genPuzzle(lv.n, lv.n === 5 ? 80 : 60);
    S.sol = pz.sol;
    S.clues = pz.clues;
    S.grid = [];
    for (var r = 0; r < lv.n; r++) S.grid.push(new Array(lv.n).fill(-1));
    S.hist = []; S.ended = false; S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    renderLevels();
    syncLevels();
    buildBoard();
    renderClues();
    renderStatus();
    renderRecord();
    renderNote('点格子轮换候选：一行是一栋房。线索在上面，全填对就赢——填错不扣分，查一查会讲。', '');
    save();
  }

  function renderLevels() {
    var box = ui.levels;
    box.textContent = '';
    for (var i = 0; i < LEVELS.length; i++) {
      (function (lv, di) {
        var b = el('button', 'st-llk-pack-btn');
        b.type = 'button';
        b.setAttribute('data-level', String(i));
        b.setAttribute('role', 'radio');
        b.appendChild(el('span', 'st-llk-pack-name', lv.name));
        b.appendChild(el('small', 'st-llk-pack-hint', lv.hint));
        b.addEventListener('click', function () {
          if (S.mode === lv.mode) return;
          newGame(di);
        });
        box.appendChild(b);
      })(LEVELS[i], i);
    }
  }

  function syncLevels() {
    var btns = ui.levels.querySelectorAll('[data-level]');
    for (var i = 0; i < btns.length; i++) {
      var on = Number(btns[i].getAttribute('data-level')) === LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode);
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function buildBoard() {
    var board = ui.board;
    board.textContent = '';
    var table = el('table', 'st-zb-table');
    var thead = el('thead');
    var hr = el('tr');
    hr.appendChild(el('th', '', '房'));
    for (var a = 0; a < S.n; a++) hr.appendChild(el('th', '', S.attrs[a].name));
    thead.appendChild(hr);
    table.appendChild(thead);
    var tbody = el('tbody');
    for (var r = 0; r < S.n; r++) {
      (function (rr) {
        var tr = el('tr');
        tr.appendChild(el('td', 'st-zb-house', String(rr + 1)));
        for (var a2 = 0; a2 < S.n; a2++) {
          (function (aa) {
            var td = el('td', 'st-zb-cell');
            td.setAttribute('data-row', String(rr));
            td.setAttribute('data-col', String(aa));
            td.setAttribute('data-val', '-1');
            td.textContent = '—';
            td.addEventListener('click', function () { onCell(rr, aa); });
            tr.appendChild(td);
          })(a2);
        }
        tbody.appendChild(tr);
      })(r);
    }
    table.appendChild(tbody);
    board.appendChild(table);
    renderGrid();
  }

  function renderGrid() {
    var cells = ui.board.querySelectorAll('.st-zb-cell');
    for (var i = 0; i < cells.length; i++) {
      var r = Number(cells[i].getAttribute('data-row')), a = Number(cells[i].getAttribute('data-col'));
      var v = S.grid[r][a];
      cells[i].setAttribute('data-val', String(v));
      cells[i].textContent = v < 0 ? '—' : S.attrs[a].vals[v];
      cells[i].classList.remove('is-bad');
    }
  }

  function renderClues() {
    var box = ui.clues;
    box.textContent = '';
    S.clues.forEach(function (c, i) {
      var li = el('li', 'st-zb-clue', clueText(c, S.attrs, S.n));
      li.setAttribute('data-clue', String(i));
      box.appendChild(li);
    });
  }

  function renderStatus() {
    var filled = 0, total = S.n * S.n;
    for (var r = 0; r < S.n; r++) for (var a = 0; a < S.n; a++) if (S.grid[r][a] >= 0) filled++;
    var lvName = '';
    for (var k = 0; k < LEVELS.length; k++) { if (LEVELS[k].mode === S.mode) lvName = LEVELS[k].name; }
    ui.status.className = 'st-status';
    ui.status.textContent = lvName + ' · 已填 ' + filled + '/' + total + ' 格 · 线索 ' + S.clues.length + ' 条';
  }

  function renderNote(text, tone) {
    ui.note.textContent = text || '';
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    for (var i = 0; i < LEVELS.length; i++) {
      var r = rec['x' + i];
      var val = r && r.wins ? (r.wins + ' 局') : '还没通关过';
      var d = el('div', 'st-llk-stat');
      d.appendChild(el('span', 'st-llk-stat-label', LEVELS[i].name + '完成'));
      d.appendChild(el('strong', 'st-llk-stat-value', val));
      box.appendChild(d);
    }
  }

  function onCell(r, a) {
    if (S.ended) return;
    S.hist.push({ grid: S.grid.map(function (row) { return row.slice(); }) });
    S.grid[r][a] = (S.grid[r][a] + 1) % S.n;
    sfx('sel');
    renderGrid();
    renderStatus();
    checkFilled();
  }

  // 填满即终局判定：全对赢；有错当场讲「有错」并保持可编辑
  function checkFilled() {
    var full = true, allOk = true;
    for (var r = 0; r < S.n; r++) {
      for (var a = 0; a < S.n; a++) {
        if (S.grid[r][a] < 0) { full = false; }
        else if (S.grid[r][a] !== S.sol[r][a]) { allOk = false; }
      }
    }
    if (!full) return;
    if (allOk) { winGame(); return; }
    sfx('bad');
    renderNote('填满了，但有不对的格子——点「查一查」找出第一个错格，讲清它该是谁。', 'bad');
  }

  function undo() {
    if (S.ended || !S.hist.length) {
      renderNote('这一步之前没有操作可撤。', '');
      return;
    }
    var back = S.hist.pop();
    S.grid = back.grid;
    sfx('sel');
    renderGrid();
    renderStatus();
    renderNote('退回上一步。', '');
  }

  // 查一查：找第一个错格（相对唯一解），讲正确答案与相关线索
  function checkBoard() {
    if (S.ended) return;
    for (var r = 0; r < S.n; r++) {
      for (var a = 0; a < S.n; a++) {
        if (S.grid[r][a] !== S.sol[r][a]) {
          var right = S.attrs[a].vals[S.sol[r][a]];
          var cl = relatedClue(r, a);
          var cells = ui.board.querySelectorAll('.st-zb-cell');
          for (var k = 0; k < cells.length; k++) cells[k].classList.remove('is-bad');
          var bad = ui.board.querySelector('.st-zb-cell[data-row="' + r + '"][data-col="' + a + '"]');
          if (bad) bad.classList.add('is-bad');
          renderNote('第 ' + (r + 1) + ' 栋房的' + S.attrs[a].name + '应该是「' + right + '」'
            + (cl ? '——看线索 ' + (cl.idx + 1) + '：「' + cl.text + '」' : '')
            + '（第 ' + (a + 1) + ' 列那个闪红的格子）。', 'bad');
          return;
        }
      }
    }
    var filledAll = true;
    for (var r2 = 0; r2 < S.n; r2++) for (var a2 = 0; a2 < S.n; a2++) if (S.grid[r2][a2] < 0) filledAll = false;
    if (!filledAll) {
      renderNote('已填的格子全部正确！还没填满——继续推。', 'ok');
      return;
    }
    winGame();
  }

  // 与「房 r 属性 a = 正确值 v」相关的线索：直接指认优先，其次涉及该值的关系线索
  function relatedClue(r, a) {
    var v = S.sol[r][a];
    var cands = [];
    for (var i = 0; i < S.clues.length; i++) {
      var c = S.clues[i];
      var hit = false;
      if (c.type === 'direct') hit = (c.attr === a && c.house === r);
      else {
        var hit1 = (c.a1 === a && c.v1 === v);
        var hit2 = (c.a2 === a && c.v2 === v);
        hit = hit1 || hit2;
      }
      if (hit) cands.push({ idx: i, c: c, text: clueText(c, S.attrs, S.n) });
    }
    for (var j = 0; j < cands.length; j++) {
      if (cands[j].c.type === 'direct') return cands[j];
    }
    return cands.length ? cands[0] : null;
  }

  function winGame() {
    S.ended = true;
    sfx('win');
    var rec = loadRecord();
    var key = 'x' + LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode);
    var cur = rec[key];
    if (!cur || typeof cur !== 'object' || Array.isArray(cur)) cur = { wins: 0 };
    cur.wins++;
    rec[key] = cur;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 静默 */ }
    renderRecord();
    ui.status.className = 'st-status is-over';
    ui.status.textContent = '推出来了！全部对上唯一解——点「新开一局」再来一题。';
    renderNote('每条线索都用到刀刃上了：这局只发了「恰好推出唯一解」的线索量——多一条都算剧透，少一条就解不动。', 'ok');
    save();
  }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderNote('再点一次「重置成绩」确认清空；点别的按钮取消。', 'bad');
      S.resetTimer = setTimeout(function () { S.resetArm = false; }, 4000);
      return;
    }
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    S.resetArm = false;
    try { localStorage.removeItem(RECORD_KEY); } catch (e) { /* 静默 */ }
    renderRecord();
    renderNote('成绩已清空。', '');
  }

  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return (r && typeof r === 'object' && !Array.isArray(r)) ? r : {};
    } catch (e) { return {}; }
  }

  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime, seq;
      if (kind === 'win') seq = [[523, 0], [659, 0.1], [784, 0.2], [1046, 0.3]];
      else if (kind === 'bad') seq = [[196, 0], [185, 0.09]];
      else seq = [[392, 0]];
      for (var i = 0; i < seq.length; i++) {
        var o = actx.createOscillator(), g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0], t + seq[i][1]);
        g.gain.setValueAtTime(0.0001, t + seq[i][1]);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.42 : 0.18, t + seq[i][1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + seq[i][1] + (SFX_MOBILE ? 0.2 : 0.14));
        o.connect(g); g.connect(actx.destination);
        o.start(t + seq[i][1]); o.stop(t + seq[i][1] + (SFX_MOBILE ? 0.26 : 0.16));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  function save() {
    try {
      localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, mode: S.mode, soundOn: S.soundOn }));
    } catch (e) { /* 存储不可用静默 */ }
  }

  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (!d || d.v !== 1) return;
      if (d.mode === 'easy' || d.mode === 'mid' || d.mode === 'hard') S.mode = d.mode;
      S.soundOn = d.soundOn !== false;
    } catch (e) { /* 忽略脏数据 */ }
  }

  function bindSoundPicker() {
    var btns = document.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          var all = document.querySelectorAll('[data-st-sound]');
          for (var j = 0; j < all.length; j++) {
            var on = all[j].getAttribute('data-st-sound') === 'on' === S.soundOn;
            all[j].classList.toggle('is-active', on);
            all[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          save();
          if (S.soundOn) sfx('sel');
        });
      })(btns[i]);
    }
  }

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.board = root.querySelector('[data-st-zb-board]');
    ui.clues = root.querySelector('[data-st-zb-clues]');
    ui.levels = root.querySelector('[data-st-zb-levels]');
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.record = root.querySelector('[data-st-record]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.undoBtn = root.querySelector('[data-st-zb-undo]');
    ui.checkBtn = root.querySelector('[data-st-check]');
    ui.resetBtn = root.querySelector('[data-st-reset]');
    if (!ui.board || !ui.levels || !ui.clues) return;

    restorePrefs();
    renderLevels();
    bindSoundPicker();

    ui.newBtn.addEventListener('click', function () { newGame(LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode)); });
    ui.checkBtn.addEventListener('click', checkBoard);
    ui.undoBtn.addEventListener('click', undo);
    ui.resetBtn.addEventListener('click', resetRecord);

    newGame(LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode));
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与复用钩子 ============ */

  global.STZebra = {
    solveCount: solveCount,
    genPuzzle: genPuzzle,
    clueText: clueText,
    clueOk: clueOk,
    buildPool: buildPool,
    levels: LEVELS,
    attrs: ATTRS,
    state: function () { return { n: S.n, attrs: S.attrs, sol: S.sol, clues: S.clues, grid: S.grid, mode: S.mode, ended: S.ended }; }
  };
})(typeof window !== 'undefined' ? window : globalThis);
